export default __webpack_public_path__ + "static/icon-b929544a56d931873fa510ca124c8a1c.png";